import type { FC, ReactNode } from 'react'

import { Ornament } from '@/components/generals/ornament'

import {
    CallButton,
    DirectionsButton,
    WhatsAppButton
} from '@/components/generals/cta-buttons'

import { hours } from '@/constants/site'

interface CtaSectionProps {
    title?: string
    message?: string
}

export const CtaSection: FC<CtaSectionProps> = ({
    title = 'Book your appointment today',
    message
}): ReactNode => {
    return (
        <section aria-labelledby='cta-title' className='bg-background pb-20 sm:pb-24'>
            <div className='mx-auto max-w-7xl px-5 sm:px-8'>
                <div className='plum-glow relative isolate overflow-hidden rounded-[2rem] px-6 py-14 text-center text-ivory shadow-2xl shadow-plum/25 sm:px-12 sm:py-16'>
                    <div aria-hidden='true' className='pointer-events-none absolute -right-20 -top-20 -z-10 size-72 rounded-full bg-gold/15 blur-3xl' />
                    <div aria-hidden='true' className='pointer-events-none absolute -bottom-24 -left-16 -z-10 size-72 rounded-full bg-plum/60 blur-3xl' />

                    <p className='gold-shine inline-block px-3 pb-2 font-script text-4xl leading-tight sm:text-5xl'>
                        Your beauty, our care
                    </p>

                    <h2 id='cta-title' className='mx-auto mt-2 max-w-2xl font-heading text-2xl font-semibold leading-tight sm:text-4xl'>
                        {title}
                    </h2>

                    <Ornament className='mx-auto mt-5' />

                    <p className='mx-auto mt-5 max-w-xl text-base leading-relaxed text-ivory/75'>
                        Message us on WhatsApp or give us a call. We are {hours.days.toLowerCase()}, {hours.label}.
                    </p>

                    <div className='mt-8 flex flex-col items-stretch justify-center gap-3 sm:flex-row sm:flex-wrap sm:items-center'>
                        <WhatsAppButton message={message} variant='gold' />
                        <CallButton variant='outline-light' />
                        <DirectionsButton variant='outline-light' />
                    </div>
                </div>
            </div>
        </section>
    )
}
